const TelegramNotificationColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 70
  },
  {
    title: 'Contact Group',
    dataIndex: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description),
    width: 150
  },
  {
    title: 'Registration Code',
    dataIndex: 'registrationCode',
    slot: 'registrationCode',
    width: 200
  },
  {
    title: 'Private Registration Link',
    dataIndex: 'telegramLink',
    slot: 'telegramLink',
    width: 350
  },
  {
    title: 'Total Subscriptions',
    dataIndex: 'totalSubscriptions',
    width: 150
  },
  {
    title: 'Actions',
    dataIndex: '',
    slot: 'actions',
    width: 150
  }
];

export { TelegramNotificationColumn };
